import {useParams} from 'react-router';
import {DictionaryItem, RouteParams} from '../../types/common';
import {useDispatch, useSelector} from 'react-redux';
import {selectDictionaries} from '../../slices';
import {useCallback} from 'react';
import {deleteDictionary, setDictionary} from '../../slices/dictionariesSlice';
import {createDictionaryParams, getDictionary, getEnumDictionary} from './usePageSchema';
import {useQuery} from '@tanstack/react-query';

type UseDictionaryProps = {
    code?: string;
    key?: string;
    need?: boolean;
    fromStore?: boolean;
    enumDict?: boolean;
};

export const useDict = ({
    code,
    key,
    need = true,
    fromStore = false,
    enumDict = false,
}: UseDictionaryProps): {data: DictionaryItem[]; isLoading: boolean; isError: boolean} => {
    const params = useParams<RouteParams>();
    const dispatch = useDispatch();
    const dictionaries = useSelector(selectDictionaries);

    const handleGetDictionary = useCallback(async () => {
        if (!code || !need) return [];
        if (fromStore && dictionaries[code]) {
            return dictionaries[code] || [];
        }
        dispatch(deleteDictionary({code}));
        const dictionaryParams = createDictionaryParams(params);
        const data = enumDict
            ? await getEnumDictionary({
                  code,
                  params: {key, ...dictionaryParams},
              })
            : await getDictionary({
                  code,
                  params: {key, ...dictionaryParams},
              });
        if (data) {
            dispatch(setDictionary({[code]: data}));
            //@ts-ignore
            return data as DictionaryItem[];
        }
        return [];
    }, [code, need, fromStore, dispatch, params, enumDict, key, dictionaries]);

    const {data, isError, isLoading} = useQuery({
        queryKey: [`getDictionary/${code}`],
        queryFn: handleGetDictionary,
        initialData: code ? dictionaries[code] : [],
    });

    return {data, isError, isLoading};
};
